export * from './projekt-delete-request.interface';
export * from './projekt-delete-response.interface';
export * from './projekt-delete.shapes';
